// extracted by mini-css-extract-plugin
module.exports = {"window":"Window_window__3CXHw","content":"Window_content__24a16"};